module.exports = __webpack_public_path__ + "img/hotel-success.50295c47.svg";